import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  PagedResult,
  StaffSignInEvent,
  StaffSignInQuery,
  StaffSignInSession
} from '../models/staff-sign-ins.model';

/**
 * Reads the staff sign-in log. SuperAdmin only server-side, like the admin audit trail: Support
 * appears IN this log rather than being able to read it, so anything here answers 403 for them.
 * Rows are never edited and are kept for six months.
 */
@Injectable({ providedIn: 'root' })
export class StaffSignInsService {
  private readonly baseUrl = environment.subscriptionApiUrl + '/api/admin/security/staff-sign-ins';

  constructor(private http: HttpClient) {}

  /** One row per sign-in, paired with how and when it ended (`view=sessions`, the default). */
  search(query?: StaffSignInQuery & { view?: 'sessions' }): Observable<PagedResult<StaffSignInSession>>;
  /** Every raw row of the log (`view=events`). */
  search(query: StaffSignInQuery & { view: 'events' }): Observable<PagedResult<StaffSignInEvent>>;
  search(query: StaffSignInQuery = {}): Observable<PagedResult<StaffSignInSession | StaffSignInEvent>> {
    return this.http.get<PagedResult<StaffSignInSession | StaffSignInEvent>>(this.baseUrl, {
      params: this.toParams(query)
    });
  }

  /** Drops empty filters so the query string only carries what the user actually chose. */
  private toParams(query: Record<string, any>): HttpParams {
    let params = new HttpParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    });
    return params;
  }
}
